import React from 'react'; //fdsffde
import SimpleImageSlider from 'react-simple-image-slider';
import radial_bg_home from '../../assets/images/radial_bg_home.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper';
import { useEffect } from 'react';
import Slider from 'react-slick';

import Link from '../../components/Link/Link';
import user2 from '../../assets/images/user2.png';
import banner from '../../assets/images/banner.png';
import phone from '../../assets/images/phone.png';
import becomePOSP from '../../assets/images/becomePOSP_img.svg';
import zeroInvestment from '../../assets/images/zeroInvestment.png';
import yourOwnBoss from '../../assets/images/yourOwnBoss.png';
import insurer from '../../assets/images/insurer.png';
import ellips from '../../assets/images/ellips.png';
import clock from '../../assets/images/clock.png';
import customer_support from '../../assets/images/customer_support.png';
import two_wheeler from '../../assets/images/two_wheeler.png';
import four_wheeler from '../../assets/images/four_wheeler.png';
import pcv from '../../assets/images/public_carry_icon.svg';
import gcv from '../../assets/images/gross_carry_icon.svg';
import health from '../../assets/images/health_icon.svg';
import travel from '../../assets/images/travel_icon.svg';
import termlife from '../../assets/images/term_icon.svg';
import home from '../../assets/images/home_icon.svg';
import life from '../../assets/images/life_icon.svg';
import business from '../../assets/images/business_icon.svg';
import critical from '../../assets/images/critical_care_icon.svg';
import whyInsurance from '../../assets/images/why_insurance.jpg';
import personal from '../../assets/images/personal_accident_icon.svg';
import hdfc from '../../assets/images/hdfc.png';
import icici from '../../assets/CompanyLogo/icici_logo.png';
import digit from '../../assets/CompanyLogo/Digit.png';
import care from '../../assets/CompanyLogo/Care.jpg';
import kotak from '../../assets/CompanyLogo/Kotak.jpg';
import orient from '../../assets/CompanyLogo/Oriental.png';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import right_top_web from '../../assets/images/right_top_web.png';
import left_bottom_web from '../../assets/images/left_bottom_web.png';
import why_compare from '../../assets/images/why_compare.png';
import why_customer from '../../assets/images/why_customer.png';
import why_medical from '../../assets/images/why_medical.png';
import dots from '../../assets/images/dots.png';
import moment1 from '../../assets/images/moment1.png';
import rating from '../../assets/images/rating.svg';
import half_empty_star from '../../assets/images/half_star.svg';
import achievements from '../../assets/images/social_share/achievements.png';
import background_img from '../../assets/images/background_pattern_img.png';
import achievement from '../../assets/images/achievement_img.svg';

import user3 from '../../assets/images/user3.png';
import hardik from '../../assets/hardik.jpg';
import Vijay from '../../assets/vijay.jpg';
import rect1 from '../../assets/images/rect1.png';
import rect2 from '../../assets/images/rect2.png';
import rect3 from '../../assets/images/rect3.png';
import blue_star from '../../assets/images/blue_star.png';
import download_icon from '../../assets/images/download_icon.png';
import play_store from '../../assets/images/play_store.png';
import squares from '../../assets/images/squares.png';
import triangle_web from '../../assets/images/triangle_web.png';
import award1 from '../../assets/images/award1.png';
import award2 from '../../assets/images/award2.png';
import award3 from '../../assets/images/award3.png';
import award4 from '../../assets/images/award4.png';
import award5 from '../../assets/images/award5.png';
import award6 from '../../assets/images/award6.png';
import phone_mockup from '../../assets/images/phone_mockup.png';
import './Home.css';
import { Accordion } from 'flowbite-react';
import CompanySlider from './CompanySlider';

const Home = () => {
  const productArray = [
    {
      url: two_wheeler,
      text: 'Two Wheeler Insurance',
      route: '',
      canLogin: true,
    },
    {
      url: four_wheeler,
      text: 'Four Wheeler Insurance',
      route: '',
      canLogin: true,
    },
    { url: pcv, text: 'Public Carrying Vehicle', route: '', canLogin: false },
    { url: gcv, text: 'Gross Carrying Vehicle ', route: '', canLogin: false },
    { url: health, text: 'Health Insurance', route: '', canLogin: false },
    { url: travel, text: 'Travel Insurance ', route: '', canLogin: false },
    { url: termlife, text: 'Term Life Insurance', route: '', canLogin: false },
    { url: home, text: 'Home  Insurance', route: '', canLogin: false },
    { url: life, text: 'Life Insurance', route: '', canLogin: false },
    { url: business, text: 'Business Insurance', route: '', canLogin: false },
    {
      url: critical,
      text: 'Critical Illness Insurance',
      route: '',
      canLogin: false,
    },
    {
      url: personal,
      text: 'Personal Accident Insurance',
      route: '',
      canLogin: false,
    },
  ];

  const companyArray = [
    { url: hdfc },
    { url: icici },
    { url: kotak },
    { url: care },
    { url: orient },
    { url: digit },
  ];
  const bannerArray = [
    { url: hdfc },
    { url: icici },
    { url: kotak },
    { url: care },
    { url: orient },
    { url: digit },
  ];

  const kpiData = [
    { heading: 'Policies Sold', content: '300000+' },
    { heading: 'Corporate & SME Clients', content: '100+' },
    { heading: 'Branch Offices', content: '21+' },
    { heading: 'Online Policies Sold', content: '1500000+' },
    { heading: 'Insurance Partners', content: '35+' },
    { heading: 'Expert Professionals', content: '300+' },
  ];

  const momentsArray = [
    { award: award1, name: '' },
    { award: award2, name: '' },
    { award: award3, name: '' },
    { award: award4, name: '' },
    { award: award5, name: '' },
    { award: award6, name: '' },
  ];

  const sliderSets = {
    dots: true,
    infinite: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    // speed: 2000,
    autoplaySpeed: 4000,
    cssEase: 'linear',
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const insurance_info = [
    { text: 'Policies Sold', img: 'url', count: 300000 },
    { text: 'Corporate & SME Clients', img: 'url', count: 100 },
    { text: 'Insurance Partners', img: 'url', count: 35 },
    { text: 'Branch Offices', img: 'url', count: 21 },
    { text: 'Online Policies Sold', img: 'url', count: 150000 },
    { text: 'Expert Professionals', img: 'url', count: 300 },
  ];

  const questionArray = [
    {
      question: 'Why not other companies website?',
      ans: 'Here in Insure Efficient, we offer personalized advice, choice, convenience, advocacy, customization, and potential cost savings for cost. Our team serve as trusted advisors who simplify the insurance process and help customers secure the coverage that best suits their needs.',
    },
    {
      question: 'What are the products sold ?',
      ans: 'We Serve all the insurance products there are be it Motor, Health, Travel, Fire & Burglary, etc to help you in your unfortunate situation.',
    },
    {
      question: 'How do I find the right product on Insure Efficient?',
      ans: 'Remember that finding the right insurance product can sometimes be a complex process, and it may require persistence and exploration of different avenues. Patience, clear communication, and being proactive with Insure Efficient team will increase your chances of finding a suitable insurance solution.',
    },
    {
      question: 'How long does it take to buy insurance on insure efficient?',
      ans: 'Its important to communicate your desired timeline and any urgent needs to the team so they can work accordingly and provide you with a realistic timeframe for the process',
    },
  ];
  useEffect(() => {
    sessionStorage.clear();
  }, []);

  return (
    <div className="w-full -mt-16">
      <div className="relative">
        {' '}
        <div
          // style={{ backgroundImage: `url(${radial_bg_home})` }}
          className="p-8 md:py-8 md:pr-20 lg:pr-2 relative z-10"
        >
          <div className="flex flex-col md:flex-row items-center pb-4 2xl:ml-24 2xl:mt-12  ">
            <div className="w-full md:w-2/5 ml-2 flex flex-col items-center lg:items-start lg:mt-20">
              {/* <p className="text-5xl font-extrabold insure">Buy Insurance,</p>
              <p className="text-5xl ">The Smart Way!</p> */}
              <p className="text-4xl font-bold insure text-blue-900">
                Find Your Right Insurance
                <br /> Fit In A Minute
              </p>
              <p className="text-xs font-medium my-8 w-2/5 md:w-full">
                Compare, Buy and Save on all your insurance needs and insure
                your loved ones
              </p>
              <div className="flex flex-col md:flex-row my-2 gap-4 lg-gap-2 items-center">
                <div>
                  <button className="h-12 bg-gradient-to-r  from-violet-500 to-fuchsia-500 px-8 py-1 rounded-xl text-white text-sm w-max gradient">
                    GET QUOTE
                  </button>
                </div>

                <div className="flex flex-row m-2">
                  <img src={clock} alt="clock" className="w-8 h-8" />
                  <p className="text-xs font-bold  ml-2">
                    Quick, Easy & Hassle Free
                  </p>
                </div>
                <div className="flex flex-row m-2">
                  <img
                    src={customer_support}
                    alt="support"
                    className="w-8 h-8"
                  />
                  <p className="text-xs font-bold  ml-2">
                    100% Claims <br /> Support
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full sm:max-sm:w-1/2 md:w-2/3">
              <img
                src={banner}
                alt="user"
                className="m-[0_auto] hidden md:block"
              />
            </div>
          </div>
          <div className="flex gap-x-2 flex-wrap gap-y-12 justify-around lg:gap-y-12 lg:gap-x-8 xl:px-40 2xl:px-80 lg:my-12">
            {productArray.map((item, index) => {
              return (
                <Link
                  key={index}
                  to={
                    item.canLogin === true
                      ? '/posp/login'
                      : '/under-construction'
                  }
                >
                  <div
                    className="w-28 h-28 bg-white rounded-lg flex flex-col justify-end items-center border-b-8 border-white hover:border-b-8 hover:border-red-500 cursor-pointer text-center  shadow-md flex-initial product_card hover:scale-105 duration-700"
                    key={index.toString()}
                  >
                    <img
                      src={item.url}
                      alt=""
                      className="w-12 h-12 mt-2 mb-2"
                    />
                    <p className="text-sm font-semibold pb-2  ">{item.text}</p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
        <img
          src={radial_bg_home}
          alt=""
          className="w-full h-3/4 top-0 absolute z-0"
        />
      </div>
      <div className="flex flex-col md:flex-row pt-12 2xl:ml-24 xs:mx-10">
        <div className="w-full md:w-4/5 px-12">
          <p className="text-3xl font-bold md:w-3/5 my-4 lg:w-full">
            Compare, Buy and Save on all your Insurance Needs
          </p>
          <p className="text-base font-normal md:w-2/5 my-8 lg:w-full">
            Identify the best value. Understand your options. Enjoy peace of
            mind.
          </p>
          <button className="h-12 bg-gradient-to-r from-violet-500 to-fuchsia-500 px-8 py-1 rounded-xl text-white text-sm my-8 gradient">
            GET QUOTE
          </button>
        </div>
        <div className="w-full  md:w-3/3 z-10  ">
          <img src={phone} alt="" className="relative w-full h-full mob" />
        </div>
        <img
          src={ellips}
          alt=""
          className="w-2/4 md:w-1/4 right-0 bottom-0 z-1  before:block "
        />
      </div>

      <div className="flex flex-col lg:flex-row pt-12 xs:mx-10 bg-white pl-24">
        <div className="w-full md:w-4/5 px-12">
          <p className="text-4xl font-bold md:w-3/5 my-4 lg:w-full">
            Your Second Source of Income is Calling
          </p>
          <p className="text-4xl font-extrabold insure">
            Become a POSP with Insure Efficient
          </p>
          <div>
            <div className="flex flex-col md:flex-row pt-12 xs:mx-10">
              <img src={zeroInvestment} className="mr-2 w-10 h-10" />
              <p className="text-xl">Zero Investment</p>
            </div>

            <div className="flex flex-col md:flex-row pt-5 xs:mx-10">
              <img src={insurer} className="mr-2 w-10 h-10" />
              <p className="text-xl">Be your Own Boss</p>
            </div>

            <div className="flex flex-col md:flex-row pt-5 xs:mx-10">
              <img src={yourOwnBoss} className="mr-2 w-10 h-10" />
              <p className="text-xl">Get access to 35+ Insurers</p>
            </div>
          </div>
          <Link
            to={'/posp/register'}
            // onClick={m.click ?? undefined}
            // className="text-sm px-2"
          >
            <button className="h-12 bg-gradient-to-r from-violet-500 to-fuchsia-500 px-8 py-1 rounded-xl text-white text-sm my-8 gradient">
              REGISTER NOW
            </button>
          </Link>
        </div>
        <div className="w-full md:w-3/3 z-10 mr-32 mt-8 ">
          <img
            src={becomePOSP}
            alt=""
            className="relative w-full h-full"
            style={{ transform: 'scale(1.3)' }}
          />
        </div>
      </div>

      <div className="relative  md:py-16 md:px-24 lg:px-2">
        <div className="px-12 mt-4 2xl:ml-12">
          <p className="text-4xl font-extrabold ml-8">
            Our{' '}
            <span className="text-4xl font-extrabold insure ml-1">
              Partners
            </span>
          </p>
          <p className="w-[300px] mb-7 md:w-2/5 text-base font-normal pt-4 lg:w-3/5 ml-8">
            {`  As an insurance broker in India, we partner with the biggest and best insurance providers in the country to provide people with the right options to choose from.`}
          </p>
        </div>
        <div className="place-content-center px-8">
          <CompanySlider />
        </div>
        {/* <div className="mx-4 flex flex-row flex-wrap gap-x-12 2xl:gap-x-24 gap-y-6 justify-center pt-12">
          {companyArray.map((item, index) => {
            return (
              <div
                key={index.toString()}
                className="w-32 flex justify-center items-center p-2 shadow-md flex-initial"
              >
                <img src={item.url} alt="" className="w-auto h-auto" />
              </div>
            );
          })}
          <SimpleImageSlider
            width={window.innerWidth - 200}
            height={300}
            images={bannerArray}
            showBullets={false}
            showNavs={true}
            autoPlay={true}
          />
          
        </div> */}
        {/* <img
          src={right_top_web}
          alt=""
          className="w-2/4 h-full right-0 top-0  absolute"
        />{' '}
        <img
          src={left_bottom_web}
          alt=""
          className="w-2/4 h-full left-0 bottom-0  absolute"
        /> */}
      </div>
      <div className="p-12 md:py-16 md:px-28 lg:px-8 text-center lg:text-start relative flex flex-col justify-center md:flex-row bg-white">
        <div className="flex justify-center lg:justify-start items-center mr-8">
          <div className="w-[527px]  lg:ml-4">
            <p className="text-4xl font-extrabold">
              Why Choose
              <p className="text-4xl font-extrabold insure">
                Insure Efficient?
              </p>
            </p>
            <p className="text-base font-normal pt-8">
              {`Buying insurance online can be overwhelming and time-consuming. With
            Insure Efficient, you can quickly compare insurance plans from
            India’s leading insurance providers and buy the plan that best
            serves your needs. We help you and your loved ones stay prepared
            financially for the biggest challenges in your life.`}
            </p>
            <img
              src={whyInsurance}
              alt=""
              className=" h-full mt-4 rounded-2xl object-contain"
            />
          </div>
        </div>
        <div className="z-10 ml-8">
          <div className="border-none border-[] rounded-3xl p-0 m-4 bg-white w-[300px] shadow-xl">
            <img src={why_medical} alt="" className="w-full rounded-2xl" />
            <p className="text-lg font-bold pt-4 px-6">
              Simplest tool to compare insurance quotes
            </p>
            <p className="text-sm font-normal py-4 px-6">
              Our robust algorithms do all the hard work for you. Simply tell us
              about your requirements and then sit back while our tool finds and
              compares the top insurance quotes for you.
            </p>
          </div>
          <div className="border-none rounded-3xl p-0 m-4 bg-white w-[300px] shadow-xl">
            <img src={why_customer} alt="" className="w-full rounded-2xl" />
            <p className="text-lg font-bold pt-4 px-6">
              100% reliable and hassle-free claims support
            </p>
            <p className="text-sm font-normal py-4 px-6">
              Need a claim settled? Our expert team of doctors and lawyers is at
              your disposal. Simply give us a call and our experts will take
              care of the whole process and fight for you in case of any undue
              objections.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center z-10 ">
          <div className="border-none rounded-3xl p-0 m-4 bg-white h-max w-[300px] shadow-xl">
            <img src={why_compare} alt="" className="w-full rounded-2xl" />
            <p className="text-lg font-bold pt-4 px-6">
              Quickest way to get the best insurance deals
            </p>
            <p className="text-sm font-normal py-4 px-6">
              With just a few clicks, you get the best insurance deals offered
              by 25+ insurance companies across India. Choose the best plan from
              our list and buy it instantly by making an easy online payment. No
              paperwork required!
            </p>
          </div>
        </div>
        {/* <img
          src={triangle_web}
          alt=""
          className="w-full h-full top-0 right-0  absolute z-0"
        />
        <img
          src={dots}
          alt=""
          className="w-40 h-1/4 left-0 top-2/3  absolute"
        /> */}
      </div>
      <div className="px-4 pl-12 mb-6 md:py-4 md:px-60 relative flex flex-row flex-wrap justify-center lg:px-16 lg:ml-12">
        <div>
          <img src={achievements} alt="" />
        </div>
        {/* <div className='mt-2' style={{height:"60vh"}}>
          <img src={achievement} className='absolute h-60 place-content-center' alt="" />
          <div className='absolute place-content-center w-fit'>
            <div className='flex flex-clo-2 justify-around '>
            <div className='bg-red-200  h-10 w-10 '>hi</div>
            <div className='bg-green-200 h-10 w-10'>hi</div>
          </div>
          <div className='flex pt-20 place-content-center justify-between w-full'>
            <div className='bg-blue-200   h-10 w-10'>hi</div>
            <div className='bg-yellow-200   h-10 w-10'>hi</div>
          </div>
          <div className='flex pt-40 justify-between w-full'>
            <div className='bg-pink-300  h-10 w-10'>hi</div>
            <div className='bg-purple-200 h-10 w-10'>hi</div>
          </div>
          </div>
          <img src={background_img} className='object-contain h-screen' alt="background pattern"/>
        </div> */}
        {/* <img src={squares} alt="" className="absolute bottom-0 w-full" /> */}
      </div>
      <div className=" mt-8 md:py-16 md:px-28 relative flex flex-col lg:text-center justify-center lg:px-4">
        <p className="text-4xl font-bold my-4 pl-12 lg:mb-12 mb-12">
          Our Proud Moments
        </p>
        <div className="flex flex-row flex-wrap gap-x-12 gap-y-6 items-center justify-center pb-12 object-contain md:gap-x-16 md:mx-24 ">
          {momentsArray.map((item, index) => {
            return (
              <div key={index.toString()} className="flex-initial">
                <img
                  src={item.award}
                  alt=""
                  className=" w-36 h-24 object-contain md:h-full"
                />
                <p>{item.name}</p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="relative">
        <div className="p-12 md:py-16 md:px-28 flex flex-col gap-4 md:flex-row z-20 relative">
          <div className="w-full md:w-1/2 md:m-8">
            <p className="text-2xl md:text-3xl font-bold">
              Our Happy Customers
            </p>
            <p className="text-xl font-semibold pt-8 w-3/5">
              Thousands of unbiased reviews.
              <br /> Trusted by 10 Thousand+ customers.
            </p>
            <div className="flex flex-row pt-4 md:pt-8">
              <img src={rating} alt="" className="mr-2" />
              <img src={rating} alt="" className="mr-2" />
              <img src={rating} alt="" className="mr-2" />
              <img src={rating} alt="" className="mr-2" />
              <img src={half_empty_star} alt="" className="mr-2" />
            </div>
          </div>

          <div className="w-[550px] md:w-1/2 flex h-[450px] flex-col bg-white rounded-lg p-8">
            <Slider {...sliderSets}>
              <div>
                <div className="flex flex-col gap-y-4 xs:flex-row">
                  <img src={user3} alt="" className="w-20 h-20" />
                  <div className="flex flex-col xs:pl-8">
                    <p className="text-xl font-semibold"> Mr.Chetan Chauhan</p>
                    <p className="text-sm font-normal pt-2">
                      Business Owner - Mokshiva Events
                    </p>
                    <div className="flex flex-row pt-2">
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img
                        src={half_empty_star}
                        alt=""
                        className="mr-2 w-4 h-3.5"
                      />
                      <p className="text-xs">4.5</p>
                    </div>
                  </div>
                </div>
                <div className="pt-8">
                  <p className="text-sm font-normal">
                    {`"I cannot speak highly enough about the service I have received from Efficient Insurance Brokers Pvt Ltd. From the moment I contacted them, their team has been incredibly helpful and professional. They took the time to understand my unique insurance requirements and provided me with multiple options tailored to my needs. What impressed me the most was their team effort in ensuring that I received the best coverage at a competitive price. Their attention to detail and commitment to customer satisfaction are truly commendable. If you're looking for an insurance broker that delivers excellent service and has a dedicated team, look no further than Efficient Insurance Team."`}
                  </p>
                </div>
              </div>
              <div>
                <div className="flex flex-col gap-y-4 xs:flex-row">
                  <img
                    src={Vijay}
                    alt=""
                    style={{ objectFit: 'contain' }}
                    className="w-20 h-20"
                  />
                  <div className="flex flex-col xs:pl-8">
                    <p className="text-xl font-semibold"> Mr.Vijay Mishra</p>
                    <p className="text-sm font-normal pt-2">
                      Business Owner - Sun Beach Resort
                    </p>
                    <div className="flex flex-row pt-2">
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img
                        src={half_empty_star}
                        alt=""
                        className="mr-2 w-4 h-3.5"
                      />
                      <p className="text-xs">4.5</p>
                    </div>
                  </div>
                </div>
                <div className="pt-8">
                  <p className="text-sm font-normal">
                    {`"Working with Efficient Insurance Brokers Pvt Ltd has been a fantastic experience. Their team's expertise and dedication to providing top-notch service are unmatched. They took the time to assess my insurance needs and thoroughly explained the available options, making the entire process smooth and stress-free. I was impressed by their team effort in coordinating with various insurance providers to negotiate the best rates and coverage for me. Efficient Insurance Broker has exceeded my expectations, and I would highly recommend their services to anyone in need of reliable and trustworthy insurance advice."`}
                  </p>
                </div>
              </div>

              <div>
                <div className="flex flex-col gap-y-4 xs:flex-row">
                  <img
                    src={hardik}
                    style={{ objectFit: 'contain' }}
                    alt=""
                    className="w-20 h-20"
                  />
                  <div className="flex flex-col xs:pl-8">
                    <p className="text-xl font-semibold"> Mr.Hardik Somani</p>
                    <p className="text-sm font-normal pt-2">
                      COO at Sapio Analytica
                    </p>
                    <div className="flex flex-row pt-2">
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img
                        src={half_empty_star}
                        alt=""
                        className="mr-2 w-4 h-3.5"
                      />
                      <p className="text-xs">4.5</p>
                    </div>
                  </div>
                </div>
                <div className="pt-8">
                  <p className="text-sm font-normal">
                    {`"I want to express my gratitude to the team at Efficient Insurance Brokers for their exceptional service. Their knowledge and professionalism are truly commendable. They went above and beyond to understand my specific insurance requirements and offered comprehensive solutions tailored to my needs. The team at Efficient Insurance Brokers worked together seamlessly, providing me with prompt responses, timely updates, and personalized attention throughout the process. I am extremely satisfied with their service and would wholeheartedly recommend them to anyone seeking an insurance broker with a dedicated and efficient team."`}
                  </p>
                </div>
              </div>
            </Slider>

            {/* <Swiper
              // spaceBetween={30}
              // centeredSlides={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              // navigation={true}
              modules={[Autoplay, Pagination, Navigation]}
              className=" md:w-1/2 flex flex-col bg-white rounded-lg p-8"
            >
              <SwiperSlide className="w-full md:w-1/2 flex flex-col bg-white rounded-lg p-8">
                <div className="flex flex-col gap-y-4 xs:flex-row">
                  <img src={user3} alt="" className="w-20 h-20" />
                  <div className="flex flex-col xs:pl-8">
                    <p className="text-xl font-semibold"> Mr. Dilip Gor</p>
                    <p className="text-sm font-normal pt-2">Business Owner</p>
                    <div className="flex flex-row pt-2">
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img
                        src={half_empty_star}
                        alt=""
                        className="mr-2 w-4 h-3.5"
                      />
                      <p className="text-xs">4.5</p>
                    </div>
                  </div>
                </div>
                <div className="pt-8">
                  <p className="text-sm font-normal">
                    {`I have been a client of Efficient Insurance Brokers Pvt. Ltd. for over five years now, and I can confidently say that their service is exceptional. Their team goes above and beyond to ensure that I have the right coverage and the best rates for my insurance needs. They are knowledgeable, responsive, and always willing to answer any questions or concerns I have. I truly appreciate their dedication and team effort in providing me with the best insurance solutions. I highly recommend Efficient Insurance Brokers to anyone seeking top-notch service and a supportive team.`}
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="w-full md:w-1/2 flex flex-col bg-white rounded-lg p-8">
                <div className="flex flex-col gap-y-4 xs:flex-row">
                  <img src={user3} alt="" className="w-20 h-20" />
                  <div className="flex flex-col xs:pl-8">
                    <p className="text-xl font-semibold"> Mr. Chetan Chauhan </p>
                    <p className="text-sm font-normal pt-2">Business Owner - Mokshiva Events</p>
                    <div className="flex flex-row pt-2">
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img src={rating} alt="" className="mr-2 w-4 h-3.5" />
                      <img
                        src={half_empty_star}
                        alt=""
                        className="mr-2 w-4 h-3.5"
                      />
                      <p className="text-xs">4.5</p>
                    </div>
                  </div>
                </div>
                <div className="pt-8">
                  <p className="text-sm font-normal">
                    {`"I cannot speak highly enough about the service I have received from Efficient Insurance Brokers Pvt Ltd. From the moment I contacted them, their team has been incredibly helpful and professional. They took the time to understand my unique insurance requirements and provided me with multiple options tailored to my needs. What impressed me the most was their team effort in ensuring that I received the best coverage at a competitive price. Their attention to detail and commitment to customer satisfaction are truly commendable. If you're looking for an insurance broker that delivers excellent service and has a dedicated team, look no further than Efficient Insurance Team."`}
                  </p>
                </div>
              </SwiperSlide>
            </Swiper> */}
          </div>
        </div>
        <img
          src={rect1}
          alt=""
          className="absolute top-0  w-full h-[-webkit-fill-available] z-0"
        />
        <img
          src={rect2}
          alt=""
          className="absolute top-0 right-0 w-1/2 h-[-webkit-fill-available] z-10"
        />
        <img
          src={rect3}
          alt=""
          className="absolute bottom-0 right-0 w-1/2 h-[-webkit-fill-available] z-0"
        />
      </div>
      {/* <div className="flex flex-col lg:flex-row pt-12 xs:mx-10 bg-white">
        <div className="w-full md:w-4/5 px-12">
          <p className="text-4xl font-bold md:w-3/5 my-4 lg:w-full">
            Your Second Source of Income is Calling
          </p>
          <p className="text-4xl font-extrabold insure">
            Become a POSP with Insure Efficient
          </p>
          <div>
            <div className="flex flex-col md:flex-row pt-12 xs:mx-10">
              <img src={zeroInvestment} className="mr-2 w-10 h-10" />
              <p className="text-xl">Zero Investment</p>
            </div>

            <div className="flex flex-col md:flex-row pt-5 xs:mx-10">
              <img src={insurer} className="mr-2 w-10 h-10" />
              <p className="text-xl">Be your Own Boss</p>
            </div>

            <div className="flex flex-col md:flex-row pt-5 xs:mx-10">
              <img src={yourOwnBoss} className="mr-2 w-10 h-10" />
              <p className="text-xl">Get access to 35+ Insurers</p>
            </div>
          </div>

          <button className="h-12 bg-gradient-to-r from-violet-500 to-fuchsia-500 px-8 py-1 rounded-xl text-white text-sm my-8 gradient">
            REGISTER NOW
          </button>
        </div>
        <div className="w-full md:w-3/3 z-10 ">
          <img src={becomePOSP} alt="" className="relative w-full h-full" />
        </div>
      </div> */}
      <div className="bg-white py-12 xs:mx-10">
        <div className="px-12">
          <p className="font-bold text-2xl mb-5">Frequently Asked Questions</p>

          <Accordion alwaysOpen={true} style={{ border: 'none' }}>
            {questionArray.map((el) => {
              return (
                <Accordion.Panel key={el.i}>
                  <div className="mb-4 shadow-md">
                    <Accordion.Title>
                      <p className="font-bold  text-lg">{el.question}</p>
                    </Accordion.Title>
                    <Accordion.Content>
                      <p className="pl-3 pr-1  pb-2 text-gray-500 dark:text-gray-400 text-base font-normal">
                        {el.ans}
                      </p>
                    </Accordion.Content>
                  </div>
                </Accordion.Panel>
              );
            })}
          </Accordion>
        </div>
      </div>

      <div className="p-12 md:p-16 flex flex-col md:flex-row gap-4 bg-white justify-around items-center text-[#003478]">
        <img src={phone_mockup} alt="" className="h-96" />
        <div>
          <p className="text-3xl md:text-5xl font-extrabold">
            Download Our App
          </p>{' '}
          <p className="text-sm font-normal pt-4">
            Get control of all your insurance needs anywhere, anytime
          </p>
          <div className="p-4">
            <div className="flex">
              <img src={blue_star} alt="" className="h-4 w-4" />
              <p className="text-sm font-normal pl-2 pb-1">
                Compare different insurance policies
              </p>
            </div>
            <div className="flex">
              <img src={blue_star} alt="" className="h-4 w-4" />
              <p className="text-sm font-normal pl-2 pb-1">
                Buy, store and share all your policies online
              </p>
            </div>
            <div className="flex">
              <img src={blue_star} alt="" className="h-4 w-4" />
              <p className="text-sm font-normal pl-2 pb-1">
                Track your policy status on the go
              </p>
            </div>
            <div className="flex">
              <img src={blue_star} alt="" className="h-4 w-4" />
              <p className="text-sm font-normal pl-2 pb-1">
                Download your policy with a single tap
              </p>
            </div>
          </div>
        </div>
        <div>
          <img src={download_icon} alt="" className="h-22 w-48 flex" />
          <img src={play_store} alt="" className="h-16 w-48" />
        </div>
      </div>
    </div>
  );
};

export default Home;
